module.exports = __webpack_public_path__ + "assets/img/21-m.a0d5959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/21-m.jpg
// module id = HdLW
// module chunks = 0